export default __webpack_public_path__ + "static/media/grommet.2d68ce03.jpeg";